var Reverb = window.Reverb || {};

Reverb.OrderTotaler = (function () {
  var formSelector = 'form.totalable';

  function totalOrderFields($form) {
    var itemAmount = parseFloat($form.find('[data-bind-keyup=\'order-amount-product\']').val()) || 0;
    var itemShipping = parseFloat($form.find('[data-bind-keyup=\'order-negotiated-shipping\']').val()) || 0;
    var itemTax = parseFloat($form.find('[data-bind-keyup=\'order-tax-rate\']').val()) || 0;
    var quantity = parseFloat($form.find('[data-bind-keyup=\'order-quantity\']').val()) || 1;
    var total = $form.find('[data-bind=\'order-total\']');

    itemAmount = itemAmount * quantity;

    if (itemTax > 0) {
      itemAmount = itemAmount * (1 + itemTax / 100);
    }

    var calculatedTotal = itemAmount + itemShipping;

    total.val(accounting.formatNumber(calculatedTotal, 2));
  }

  function totalOrderFieldsOnChange() {
    $(document).on('keyup', '[data-bind-keyup]', function () {
      var form = $(this).parents(formSelector);
      totalOrderFields(form);
    });
  }

  function totalExistingForms() {
    $(formSelector).each(function () {
      totalOrderFields($(this));
    });
  }

  function init() {
    totalOrderFieldsOnChange();
    totalExistingForms();
  }

  return {
    init: init
  };
})();

$(function () {
  Reverb.OrderTotaler.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/order_totaler.js